/**
 * Forward geocode via OpenStreetMap Nominatim.
 * @see https://operations.osmfoundation.org/policies/nominatim/ — identify the app and avoid bulk / parallel abuse.
 */
const NOMINATIM_USER_AGENT = 'SkimBusterWeb/1.0 (sweeps map; +https://skimbuster.com)';

export async function geocodeAddressNominatim(address: string): Promise<{ lat: number; lng: number } | null> {
  const q = String(address || '').trim();
  if (!q) return null;
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(q)}&limit=1`,
      {
        headers: {
          'User-Agent': NOMINATIM_USER_AGENT,
          Accept: 'application/json',
        },
      }
    );
    if (!response.ok) return null;
    const data: unknown = await response.json();
    if (!Array.isArray(data) || data.length === 0) return null;
    const first = data[0] as { lat?: string; lon?: string };
    const lat = parseFloat(String(first.lat ?? ''));
    const lng = parseFloat(String(first.lon ?? ''));
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    return { lat, lng };
  } catch {
    return null;
  }
}

export function sleepMs(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
